/* eslint-disable */
import React, { useState, useRef } from "react";
import { Modal, Divider, Button, Box, Text } from "@mantine/core";
import ModalHeader from "components/ModalHeader";
import { useCancelLeaveRequest } from "api/newLeave/cancelLeave";

type CancelLeaveProps = {
  opened: boolean;
  isApproved?: boolean;
  onClose: () => void;
  leaveId: string;
};

function CancelLeave({
  opened,
  onClose,
  isApproved,
  leaveId,
}: CancelLeaveProps) {
  const { mutate: cancelLeave, isLoading } = useCancelLeaveRequest();
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const formRef = useRef<HTMLFormElement | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (hasSubmitted || isLoading) return;
    setHasSubmitted(true);

    if (!leaveId) {
      console.error("Leave ID is missing");
      setHasSubmitted(false);
      return;
    }

    cancelLeave(leaveId, {
      onSuccess: (res: any) => {
        console.log("Leave cancelled successfully:", res);
        setHasSubmitted(false);
        onClose();
      },
      onError: (err: any) => {
        console.error("Failed to cancel leave:", err);
        setHasSubmitted(false);
        onClose();
      },
    });
  };

  return (
    <Modal
      opened={opened}
      onClose={() => {
        setHasSubmitted(false);
        onClose();
      }}
      size="md"
      withCloseButton={false}
      transitionDuration={300}
      centered
      overlayOpacity={0.5}
    >
      <ModalHeader
        title={isApproved ? "Leave Approved" : "Cancel Leave Request"}
        onClose={onClose}
        ariaLabel="Close Status modal"
      />
      <Divider mb="md" />

      <Box
        component="form"
        ref={formRef}
        onSubmit={handleSubmit}
        style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
      >
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <Text
            size="sm" // reduced font size to match button text
            style={{
              fontWeight: 500,
              textAlign: "center",
              lineHeight: 1.4,
            }}
          >
            Are you sure you want to cancel this leave request?
          </Text>
        </Box>

        <Button
          type="submit"
          fullWidth
          loading={isLoading || hasSubmitted}
          color="red"
        >
          Yes, Cancel Leave
        </Button>
        <Button
          variant="light"
          onClick={() => {
            setHasSubmitted(false);
            onClose();
          }}
          fullWidth
          disabled={isLoading}
        >
          No, Keep It
        </Button>
      </Box>
    </Modal>
  );
}

export default CancelLeave;
